(function () {
  'use strict';

  // Fix 4: Skip names that are already native Shopify variants (appear in variant title)
  var SKIP_NAMES = [
    'properties[Scent]',
    'properties[Size]',
    'properties[Choose your Scent]',
    'properties[Choose Your Scent]'
  ];

  // Fix 1: Always return the main ATC form, never the installment/Afterpay form
  function getProductForm() {
    var productFormEl = document.querySelector('product-form');
    if (productFormEl) return productFormEl.querySelector('form');
    return document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
  }

  function injectField(form, name, value) {
    if (!name || !value || !value.trim()) return;
    // Fix 4: skip variant option names
    if (SKIP_NAMES.indexOf(name) > -1) return;

    // Find any existing hidden input with this name
    var existingOwned = null;
    var existingExternal = null;
    var allHidden = form.querySelectorAll('input[type="hidden"]');
    for (var i = 0; i < allHidden.length; i++) {
      if (allHidden[i].name === name) {
        if (allHidden[i].hasAttribute('data-sn-injected')) {
          existingOwned = allHidden[i];
        } else {
          existingExternal = allHidden[i];
        }
        break;
      }
    }
    // If already set by syncProps or similar code (not our injection), leave it alone
    if (existingExternal) return;
    // Remove our own previous injection so we inject a fresh value
    if (existingOwned) existingOwned.remove();

    var h = document.createElement('input');
    h.type = 'hidden';
    h.name = name;
    h.value = value.trim();
    h.setAttribute('data-sn-injected', '1');
    form.appendChild(h);
  }

  function injectPersonalisationIntoForm(form) {
    // Sweep 1: generic — all [name^="properties["] inputs outside the form
    var allPropInputs = document.querySelectorAll(
      'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
    );
    allPropInputs.forEach(function (input) {
      if (form.contains(input)) return;
      if (input.disabled) return;
      if (input.type === 'file') return; // SN FIX: never copy file inputs as text (produces C:\\fakepath\\ and loses the real upload)
      injectField(form, input.name, input.value);
    });

    // Sweep 2: birth flower — catch by class/ID pattern even if name differs
    var birthSelectors = [
      '[class*="birth-flower"] input',
      '[class*="birth-flower"] select',
      '[class*="birth-flower"] textarea',
      '[class*="sn-birth"] input',
      '[class*="sn-birth"] select',
      '[class*="sn-birth"] textarea',
      '[id*="birth-month"] select',
      '[id*="recipient"] input',
      '[id*="candle-message"] textarea',
      '#sn-birth-month',
      '#sn-birth-name',
      '#sn-birth-msg'
    ].join(', ');

    document.querySelectorAll(birthSelectors).forEach(function (input) {
      if (form.contains(input)) return;
      if (input.disabled) return;
      if (input.type === 'file') return; // SN FIX: never copy file inputs as text
      if (!input.value || !input.value.trim()) return;
      var name = input.name || '';
      // Wrap with properties[ if not already formatted
      if (name && !name.startsWith('properties[')) {
        name = 'properties[' + name + ']';
      }
      if (!name || name === 'properties[]') return;
      injectField(form, name, input.value);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {

    // Fix 1: ATC click intercept — fires in capture phase before form submits
    var atcBtn = document.querySelector(
      '[name="add"], #AddToCart, .product-form__submit, button[type="submit"].product-form__submit'
    );
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var form = getProductForm();
        if (form) injectPersonalisationIntoForm(form);
      }, true);
    }

    // Fix 2: Mobile scroll preservation — save position before variant change,
    // restore if Dawn's renderProductInfo DOM swap shifts the page
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el.closest && (el.closest('variant-radios') || el.closest('variant-selects'))) {
        var savedY = window.scrollY || window.pageYOffset;
        setTimeout(function () {
          var currentY = window.scrollY || window.pageYOffset;
          if (Math.abs(currentY - savedY) > 50) {
            window.scrollTo(0, savedY);
          }
        }, 500);
      }
    });

    // Fix 3: Fetch interceptor — for AJAX/JSON cart adds from third-party apps
    var originalFetch = window.fetch;
    window.fetch = function (url, options) {
      if (typeof url === 'string' && url.includes('/cart/add')) {
        if (options && options.body) {
          try {
            var body = JSON.parse(options.body);
            if (!body.properties) body.properties = {};
            document.querySelectorAll(
              'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
            ).forEach(function (el) {
              if (el.type === 'file') return; // SN FIX: never copy file inputs as text
              if (!el.value || !el.value.trim()) return;
              var key = el.name.replace(/^properties\[/, '').replace(/\]$/, '');
              if (SKIP_NAMES.indexOf(el.name) > -1) return;
              if (!body.properties[key]) body.properties[key] = el.value.trim();
            });
            options.body = JSON.stringify(body);
          } catch (e) { /* not a JSON body — proceed normally */ }
        }
      }
      return originalFetch.apply(this, arguments);
    };

  });

})();
// -- SN PERMANENT UI FIXES --
document.addEventListener('DOMContentLoaded', function () {

  // 1. SCENT DROPDOWN
  var fieldsets = document.querySelectorAll('fieldset.product-form__input');
  var fieldset = Array.from(fieldsets).find(function(f) {
    var legend = f.querySelector('legend');
    return legend && legend.textContent.toLowerCase().includes('scent');
  });
  if (fieldset) {
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    var scents = [], currentValue = '';
    radios.forEach(function(r) { if (r.checked) currentValue = r.value; scents.push(r.value); });
    var lbl = document.createElement('label');
    lbl.className = 'form__label';
    lbl.setAttribute('for', 'scent-dropdown');
    lbl.textContent = 'Choose your Scent';
    var sel = document.createElement('select');
    sel.id = 'scent-dropdown';
    sel.name = 'Choose your Scent';
    sel.style.cssText = 'width:100%;padding:12px 16px;border:1px solid #ccc;border-radius:6px;font-size:15px;background-color:#fff;color:#333;cursor:pointer;appearance:auto;margin-top:6px;';
    scents.forEach(function(scent) {
      var opt = document.createElement('option');
      opt.value = scent; opt.textContent = scent;
      if (scent === currentValue) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function() {
      var target = Array.from(radios).find(function(r) { return r.value === sel.value; });
      if (target) { target.click(); target.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    // Hide original radio elements so the core theme JS still functions without crashing
    radios.forEach(function(r) {
      r.style.display = 'none';
      var label = fieldset.querySelector('label[for="' + r.id + '"]');
      if (label) label.style.display = 'none';
    });
    var legend = fieldset.querySelector('legend');
    if (legend) legend.style.display = 'none';
    fieldset.appendChild(lbl);
    fieldset.appendChild(sel);
  }

  // 2. ENGRAVING LABEL
  var engLabel = document.getElementById('sn-eng-label');
  if (engLabel) engLabel.innerText = 'Engraving message HERE';

  // 3. ENGRAVING VALIDATION
  var addToCartBtn = document.querySelector('button[name="add"].product-form__submit');
  if (addToCartBtn) {
    var productForm = addToCartBtn.closest('form');
    var warningBanner = document.createElement('div');
    warningBanner.id = 'sn-engraving-warning';
    warningBanner.style.cssText = 'display:none;background:#fff3cd;border:2px solid #e6a817;border-radius:8px;padding:12px 16px;margin-top:10px;font-size:14px;color:#7d4e00;font-weight:600;text-align:center;';
    warningBanner.innerHTML = '<span id="sn-warning-text"></span>';
    addToCartBtn.parentElement.insertBefore(warningBanner, addToCartBtn);
    var shakeStyle = document.createElement('style');
    shakeStyle.textContent = '@keyframes sn-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-6px)}40%{transform:translateX(6px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}} #sn-engraving-warning.sn-shake{animation:sn-shake 0.4s ease;}';
    document.head.appendChild(shakeStyle);
    function showWarning(msg) {
      var w = document.getElementById('sn-engraving-warning');
      document.getElementById('sn-warning-text').textContent = msg;
      w.style.display = 'block';
      w.classList.remove('sn-shake'); void w.offsetWidth; w.classList.add('sn-shake');
      w.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var eng = document.getElementById('sn-eng-input');
      if (eng) { eng.style.border = '2px solid #e6a817'; eng.focus(); }
    }
    function hideWarning() {
      var w = document.getElementById('sn-engraving-warning');
      if (w) w.style.display = 'none';
      var eng = document.getElementById('sn-eng-input');
      if (eng) eng.style.border = '';
    }
    var engInput = document.getElementById('sn-eng-input');
    if (engInput) engInput.addEventListener('input', hideWarning);
    productForm.addEventListener('submit', function(e) {
      var isLarge = ((document.getElementById('sn-prop-size') || {}).value || '').toLowerCase().includes('large');
      var isMedEng = (document.getElementById('sn-cb-2') || {}).checked;
      var msg = ((document.getElementById('sn-eng-input') || {}).value || '').trim();
      if ((isLarge || isMedEng) && !msg) {
        e.preventDefault(); e.stopImmediatePropagation();
        showWarning(isLarge ? 'Your large candle includes FREE engraving - please enter your message before adding to cart!' : "You've added engraving ($5) - please enter your message before adding to cart!");
      } else { hideWarning(); }
    }, true);
  }

  // 4. HOMEPAGE GRID FIX (2026-07-06: block-ID agnostic — the old selector
  // targeted a long-dead block id. Removes any ghost card with no image,
  // whenever it appears, via MutationObserver.)
  function snCleanGiftGrids() {
    document.querySelectorAll('[class*="ai-gift-grid-cards"]').forEach(function(grid) {
      Array.prototype.slice.call(grid.children).forEach(function(card) {
        if (!card.querySelector('img') && card.textContent.trim() === '') {
          card.remove();
        }
      });
    });
  }
  snCleanGiftGrids();
  var snGridObserver = new MutationObserver(snCleanGiftGrids);
  document.querySelectorAll('[class*="ai-gift-grid-cards"]').forEach(function(grid) {
    snGridObserver.observe(grid, { childList: true });
  });

});
// ============================================================
// Fix 5: Quiz single-click advance
// The AI-generated quiz requires 2 clicks per answer to advance.
// This clones all option elements (removing broken original listeners)
// and re-attaches a clean handler that selects + auto-advances.
// ============================================================
(function fixQuizSingleClick() {
  function applyQuizFix() {
    var quizEl = document.querySelector('candle-quiz-av0vanmrrtejobjdinaigenblockb80b6edd6hdtn');
    if (!quizEl || !quizEl.querySelectorAll('[data-value]').length) {
      setTimeout(applyQuizFix, 300);
      return;
    }

    // Clone each option to strip the original broken event listeners
    quizEl.querySelectorAll('[data-value]').forEach(function(option) {
      var clone = option.cloneNode(true);
      option.parentNode.replaceChild(clone, option);
    });

    // Attach single clean listener per option
    quizEl.querySelectorAll('[data-value]').forEach(function(option) {
      option.addEventListener('click', function() {
        // Deselect siblings
        var parent = this.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-value]').forEach(function(o) {
            o.classList.remove('selected');
          });
        }
        // Select this option
        this.classList.add('selected');
        // Record answer
        var stepEl = this.closest('[data-step]');
        if (stepEl) {
          var stepNum = parseInt(stepEl.getAttribute('data-step'));
          if (!quizEl.answers) quizEl.answers = {};
          quizEl.answers[stepNum] = this.getAttribute('data-value');
        }
        // Advance to next step after brief delay (so user sees selection highlight)
        setTimeout(function() { quizEl.nextStep(); }, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(applyQuizFix, 500); });
  } else {
    setTimeout(applyQuizFix, 500);
  }
})();
// ============================================================
// Fix 6: Quiz personalised product recommendations
// Replaces the generic result screen with a specific product
// recommendation based on the customer's quiz answers.
// ============================================================
(function fixQuizRecommendations() {

  var PRODUCTS = {
    photoCandle: {
      title: 'Personalised Photo Candle',
      url: '/products/personalise-your-own-photo-candle-custom-picture-candle-scented-candle-in-australia',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Couple1candle.png',
      why: 'A candle with your favourite photo — the most personal gift you can give.'
    },
    anniversaryPhoto: {
      title: 'Anniversary Gift Personalised Photo Candle',
      url: '/products/anniversary-gift-personalised-candle',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Couple1candle.png',
      why: 'Celebrate your love story with a photo candle made just for them.'
    },
    mapCandle: {
      title: 'Personalised Map Candle – Where We Met',
      url: '/products/personalised-map-candle-valentines-day-gift-for-her-where-we-met-first-date-proposal',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Mothersdaystarmapcandle.png',
      why: 'Mark the place where your story began — a truly one-of-a-kind gift.'
    },
    birthFlower: {
      title: 'Birth Month Flower Personalised Candle',
      url: '/products/birth-flower-birthday-gift-personalised-candle',
      img: 'https://www.scentnation.com.au/cdn/shop/files/mothers-day-birth-flower-candle.png',
      why: 'Their birth month flower, beautifully personalised — perfect for Mum.'
    },
    milestone: {
      title: 'Custom Birthday Milestone Candle',
      url: '/products/custom-birthday-milestone-candle-gift',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Personalised_21st_Birthday_candle.png',
      why: 'Mark the milestone with a candle they\'ll keep long after the party.'
    },
    graduation: {
      title: 'Personalised Graduation Gift Candle',
      url: '/products/personalised-graduation-gifts-personalised-gifts-for-university-graduate-year-12-high-school-doctor-nursing-graduation',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Personalisedweddinggift.jpg',
      why: 'Celebrate their achievement with a personalised candle they\'ll treasure.'
    },
    monogram: {
      title: 'Personalised Monogram Candle',
      url: '/products/personalised-monogram-candle-perfect-gift-for-birthdays-wedding-anniversaries-christmas',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Personalised_Valentines_Gift.png',
      why: 'Elegant, timeless and completely theirs — a monogram candle they\'ll love.'
    },
    customSoy: {
      title: 'Personalised Custom Message Candle',
      url: '/products/create-your-personalised-soy-candle-custom-scented-candles-in-australia',
      img: 'https://www.scentnation.com.au/cdn/shop/files/custommessageherecandle.png',
      why: 'Write your own message — a candle that says exactly what you mean.'
    },
    dogCandle: {
      title: 'Funny & Novelty Candles – Browse the Collection',
      url: '/collections/funny-novelty-candles',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Customdog.png',
      why: 'You\'ve got a fun vibe — browse our full range of cheeky, novelty candles!'
    },
    starMap: {
      title: 'Star Map / Night Sky Candle',
      url: '/products/star-map-night-sky-candle',
      img: 'https://www.scentnation.com.au/cdn/shop/files/Mothersdaystarmapcandle.png',
      why: 'Capture the night sky from a special date — a truly magical gift.'
    },
    scentedCollection: {
      title: 'Scented Candles – Browse the Full Collection',
      url: '/collections/scented-candles',
      img: 'https://www.scentnation.com.au/cdn/shop/files/custommessageherecandle.png',
      why: 'You deserve something special — explore our full range and find your perfect scent.'
    }
  };

  function getRecommendation(answers) {
    var who = answers[1] || '';
    var occasion = answers[2] || '';
    var vibe = answers[3] || '';
    var style = answers[4] || '';

    // Fun & cheeky vibe always gets the fun candle
    if (vibe === 'fun-cheeky') return PRODUCTS.dogCandle;

    // Graduation always gets graduation candle
    if (occasion === 'graduation') return PRODUCTS.graduation;

    // Myself or Just Because → browse the full scented candles collection
    if (who === 'myself' || occasion === 'just-because') return PRODUCTS.scentedCollection;

    // Anniversary occasion
    if (occasion === 'anniversary') {
      if (style === 'photo') return PRODUCTS.anniversaryPhoto;
      return PRODUCTS.mapCandle;
    }

    // Partner
    if (who === 'partner') {
      if (style === 'photo') return PRODUCTS.anniversaryPhoto;
      if (style === 'message') return PRODUCTS.mapCandle;
      return PRODUCTS.starMap;
    }

    // Mum
    if (who === 'mum') {
      if (style === 'photo') return PRODUCTS.photoCandle;
      return PRODUCTS.birthFlower;
    }

    // Friend / Birthday
    if (occasion === 'birthday') {
      if (style === 'photo') return PRODUCTS.photoCandle;
      return PRODUCTS.milestone;
    }

    // Housewarming
    if (occasion === 'housewarming') return PRODUCTS.customSoy;

    // Default
    if (style === 'photo') return PRODUCTS.photoCandle;
    if (style === 'message') return PRODUCTS.customSoy;
    return PRODUCTS.scentedCollection;
  }

  function updateResultScreen(quizEl, answers) {
    var product = getRecommendation(answers);
    var resultScreen = quizEl.resultScreen;
    if (!resultScreen || !product) return;

    resultScreen.innerHTML =
      '<h3 class="ai-candle-quiz__result-title-av0vanmrrtejobjdinaigenblockb80b6edd6hdtn">Perfect! Here\'s Your Match 🎉</h3>' +
      '<img src="' + product.img + '" alt="' + product.title + '" style="width:160px;height:160px;object-fit:cover;border-radius:8px;margin:12px auto;display:block;" />' +
      '<p style="font-weight:600;font-size:17px;margin:8px 0 4px;">' + product.title + '</p>' +
      '<p style="font-size:14px;color:#555;margin:0 0 16px;line-height:1.4;">' + product.why + '</p>' +
      '<a href="' + product.url + '" class="ai-candle-quiz__button-av0vanmrrtejobjdinaigenblockb80b6edd6hdtn">Shop This Candle →</a>';
  }

  function applyRecommendationFix() {
    var quizEl = document.querySelector('candle-quiz-av0vanmrrtejobjdinaigenblockb80b6edd6hdtn');
    if (!quizEl) { setTimeout(applyRecommendationFix, 300); return; }

    var origShowResults = quizEl.showResults.bind(quizEl);
    quizEl.showResults = function() {
      origShowResults();
      updateResultScreen(quizEl, quizEl.answers || {});
    };

    // Override skip button
    var skipBtn = quizEl.emailScreen.querySelector('[data-action="skip-email"]');
    if (skipBtn) {
      var newSkip = skipBtn.cloneNode(true);
      skipBtn.parentNode.replaceChild(newSkip, skipBtn);
      newSkip.addEventListener('click', function() { quizEl.showResults(); });
    }

    // Override submit-email button
    var submitBtn = quizEl.emailScreen.querySelector('[data-action="submit-email"]');
    var emailInput = quizEl.emailInput;
    if (submitBtn) {
      var newSubmit = submitBtn.cloneNode(true);
      submitBtn.parentNode.replaceChild(newSubmit, submitBtn);
      newSubmit.addEventListener('click', function() {
        if (emailInput && !emailInput.value) { emailInput.reportValidity(); return; }
        quizEl.showResults();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(applyRecommendationFix, 600); });
  } else {
    setTimeout(applyRecommendationFix, 600);
  }
})();

// ============================================================
// Fix 7: Footer accordion styling (mobile).
// 2026-07-06: The footer link columns in sections/footer.liquid are native
// <details>/<summary> accordions. The old version of this fix hid
// .footer-block__details-content with display:none!important and toggled an
// .sn-open class via JS on heading.nextElementSibling — but the heading now
// sits INSIDE <summary> (next sibling = caret span), so taps on mobile never
// revealed the menu. This version keeps the mobile cosmetics only and keys
// visibility off the native details[open] state. No JS toggling needed.
// ============================================================
(function() {
  var css = '@media screen and (max-width:749px){footer.footer{background:none!important;background-image:none!important;background-color:#fff7ed!important;}.footer__content-top{background-color:#fff7ed!important;}.footer-block{border-bottom:1px solid #d4c5b0;margin:0!important;padding:0!important;}.footer__blocks-wrapper{gap:0!important;row-gap:0!important;}.footer-block__heading{cursor:pointer;display:flex;justify-content:space-between;align-items:center;padding:6px 0;margin:0!important;color:#1f1a17!important;font-size:10px!important;}.footer-block__details .footer-block__details-content{display:none;padding-bottom:6px;}.footer-block__details[open] .footer-block__details-content{display:block;}.footer-block__details-content{font-size:10px!important;}.footer-block__details-content a,.footer-block__details-content .link{color:#1f1a17!important;font-size:10px!important;}.footer__content-bottom{background-color:#fff7ed!important;color:#1f1a17!important;font-size:10px!important;}.footer__copyright,.footer__payment{color:#1f1a17!important;font-size:10px!important;}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
})();
